<template>
	<div class="container">
		<div class="top-wrapper">
				<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" v-model="username" placeholder="用户名" maxlength="11" /></div></flex-line>
				<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" placeholder="密码" maxlength="20" /></div></flex-line>
		</div>

		<div class="common-btn ds-button-large mt-10 mb-10" @click="onSubmit">绑定</div>

	</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { bind, getThirdLogin } from '../../../api/memberLogin'
import flexLine from '../../flexLine'
export default {
  name: 'BindOld',
  data () {
    return {
      username: '',
      password: '',
      wxinfo: false
    }
  },
  components: { flexLine },
  created: function () {
    getThirdLogin(this.$route.query.id).then(res => {
      let wxinfo = res.result.wxinfo
      if (!wxinfo) {
        Toast('绑定信息不存在')
        this.$router.push({ name: 'HomeMemberLogin' })
      } else {
        this.wxinfo = wxinfo
      }
    })
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId
    })
  },

  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),

    check () {
      let username = this.username
      let password = this.password
      if (username.length === 0) {
        Toast('请输入用户名')
        return false
      }

      if (password.length === 0) {
        Toast('请输入密码')
        return false
      }

      return true
    },
    signup () {
      if (!this.check()) {
        return
      }
      Indicator.open()

      bind(0, 'wx', this.wxinfo.openid, this.wxinfo.unionid, this.wxinfo.nickname, this.wxinfo.headimgurl, this.username, this.password, '', this.inviter_id).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.$router.push({ name: 'MemberIndex' })
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onSubmit () {
      this.signup()
    }

  }
}
</script>

<style scoped lang="scss">
	.ds-button-large{margin:0 $pageSpace}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		//background-color: $primaryColor;
		.input-wrapper {
			font-size:$subFontSize;
			display: flex;
			flex-direction: row;
			align-content: flex-start;
			align-items: center;
			background-color: #fff;
			height:2.2rem;
			padding-left:0.5rem;
			input {
				flex: 1;
			}
			.bottom-input {
				border-bottom-width: 0;
			}
			img{height:1.75rem}
		}

	}
	.top-wrapper {margin:0 $pageSpace;}
	.bottom-wrapper {margin-top:0.5rem;}
	.tips {
		color: $descTextColor;
		font-size:$fontSize;
		white-space: nowrap;
		position: absolute;
		right: 0;
		top:50%;
		margin-top:-.3rem;
	}
	.countdown {min-width:4rem;margin-right:0.5rem;}
	.field-line-right{position: relative}
    .field-input{
      text-align: left !important;
    }
</style>
